<template>
  <div class="c-light-video">
    <div class="c-light-video__video">
      <light-box-video-spinner />
      <vue-vimeo-player v-if="videoId" :video-id="videoId"></vue-vimeo-player>
    </div>
    <div v-if="videoDescription.length" class="c-light-video__copy">
      <prismic-rich-text :field="videoDescription" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import LightBoxVideoSpinner from "@/templates/components/LightBox/LightBoxVideoSpinner";
import PrismicRichText from "objects/PrismicRichText";
import { vueVimeoPlayer } from "vue-vimeo-player";
export default {
  components: {
    LightBoxVideoSpinner,
    PrismicRichText,
    vueVimeoPlayer
  },
  computed: {
    ...mapState({
      videoId: state => state.lightBox.youtubeId,
      videoDescription: state => state.lightBox.videoDescription
    })
  }
};
</script>

<style lang="scss">
.c-light-video {
  display: flex;
  flex-direction: column;
  max-width: 1200px;
  width: 100%;
  &__video {
    width: 100%;
    height: 100%;
    padding-bottom: 56.25%;
    position: relative;
    > div {
      position: absolute;
      width: 100%;
      height: 100%;
    }
    iframe {
      width: 100%;
      height: 100%;
    }
  }
  &__copy {
    text-align: center;
    margin-top: var(--grid-gutter-double);
    h3 {
      @include t3-heavy-bold;
      color: $color-dark;
      margin-top: 0px;
    }
  }
}
</style>
